"use client"

import Link from "next/link"
import { LogoHeader } from "@/components/shared/LogoHeader"
import { GlassCard } from "@/components/shared/GlassCard"
import { Button } from "@/components/ui/button"

export const dynamic = "force-dynamic"

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background">
      <LogoHeader />
      <main className="mx-auto max-w-3xl px-4 py-12">
        <GlassCard className="p-6 md:p-8">
          <h1 className="mb-6 text-3xl font-bold">Terms & Conditions</h1>
          
          <div className="prose prose-invert max-w-none space-y-6">
            <section>
              <h2 className="text-xl font-semibold">1. Acceptance of Terms</h2>
              <p className="text-muted-foreground">
                By accessing and using W&apos;SHU Empire services, you accept and agree to be bound by the terms and provision of this agreement.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold">2. Free Account Access</h2>
              <p className="text-muted-foreground">
                Free account users are granted access to selected resources and updates. W&apos;SHU Empire reserves the right to modify or discontinue free features at any time.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold">3. Investment Disclaimer</h2>
              <p className="text-muted-foreground">
                All investment information provided is for educational purposes only. Past performance does not guarantee future results. All investments carry risk, and you should consult with a qualified financial advisor before making investment decisions.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold">4. Privacy</h2>
              <p className="text-muted-foreground">
                Your personal information is collected and used in accordance with our Privacy Policy. We do not share your information with third parties without your consent.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold">5. Account Responsibility</h2>
              <p className="text-muted-foreground">
                You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold">6. Modifications</h2>
              <p className="text-muted-foreground">
                W&apos;SHU Empire reserves the right to modify these terms at any time. Continued use of the service constitutes acceptance of any changes.
              </p>
            </section>
          </div>

          <div className="mt-8">
            <Button asChild>
              <Link href="/signup">Back to Sign Up</Link>
            </Button>
          </div>
        </GlassCard>
      </main>
    </div>
  )
}


